import { Component } from "../../../components/base/Component";
import { ICfa } from "../../../models/ICfa";
import { ComponentFactory } from "../../../services/ComponentFactory";

export class ZipCodeSearch extends Component {
	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);
		this.initZipCodeSearch();
	}

	public initZipCodeSearch(): void {
		const input = this._element.querySelector<HTMLInputElement>("input[name='query']");
		const button = this._element.querySelector<HTMLButtonElement>("button[type='submit']");
		const form = this._element.querySelector<HTMLFormElement>("form[action]");

		if (!input || !button || !form)
			return;

		button.addEventListener("click", (event) => {
			event.preventDefault(); // Prevent form submission

			const zip = input.value.trim();
			const actionUrl = form.getAttribute("action") || "";

			// ZIP code validation was not defined on the ticket, so this is commented out.
			// const zipRegex = /^\d{5}(-\d{4})?$/;
			// if (!zipRegex.test(zip)) {
			//     alert("Please enter a valid ZIP code (e.g., 12345 or 12345-6789).");
			//     input.focus();
			//     return;
			// }

			// Build the URL with query string
			const redirectUrl = `${actionUrl}?q=${encodeURIComponent(zip)}`;

			// Redirect to the new URL
			window.location.href = redirectUrl;
		});
	}
}

ComponentFactory.registerComponent("ZipCodeSearch", ZipCodeSearch);
